import { FormSection } from './components/FormSection';
import { FormGroup } from './components/FormGroup';
import { FormField } from './components/FormField';
import { ProjectDetailsForm } from './ProjectDetailsForm';
import { BudgetForm } from './BudgetForm';
import { ValueForm } from './ValueForm';
import { CostTable } from './CostTable';
import { useProject } from '@/context/ProjectContext';
import { ProjectData } from '@/types/project';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

export function InputPanel() {
  const { state, dispatch } = useProject();
  const { data } = state;

  const handleChange = (field: keyof ProjectData, value: any) => {
    dispatch({ 
      type: 'UPDATE_DATA', 
      payload: { 
        ...data,
        [field]: value 
      } 
    });
  };

  return (
    <div className="space-y-6">
      {/* Project Details */}
      <Card>
        <CardHeader>
          <CardTitle>Project Details</CardTitle>
        </CardHeader>
        <CardContent>
          <ProjectDetailsForm
            details={data.details}
            onChange={(updates) => handleChange('details', { ...data.details, ...updates })}
          />
        </CardContent>
      </Card>

      {/* Budget */}
      <BudgetForm
        data={data}
        onChange={(type, value) => {
          if (type === 'value') {
            handleChange('value', { ...data.value, budgetedRevenue: value });
          } else {
            handleChange('costs', { ...data.costs, budgetedCosts: value });
          }
        }}
      />

      {/* Value */}
      <Card>
        <CardHeader>
          <CardTitle>Value</CardTitle>
        </CardHeader>
        <CardContent>
          <ValueForm
            value={data.value}
            onChange={(field, value) => handleChange('value', {
              ...data.value,
              [field]: value
            })}
          />
        </CardContent>
      </Card>

      {/* Costs */}
      <CostTable
        costs={data.costs}
        onChange={(field, updates) => handleChange('costs', {
          ...data.costs,
          [field]: updates
        })}
      />
    </div>
  );
}